<template>
  <div class="account-nav-tab">
    <button
      class="btn"
      type="button"
      v-for="option in options"
      :key="option.id"
      :class="{ active: value === option.id }"
      @click="$emit('input', option.id)"
    >
      {{ option.name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String
  },
  data() {
    return {
      options: [
        { id: "account", name: "Minha conta" },
        { id: "profile", name: "Perfil" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.account-nav-tab {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #373737;

  button {
    padding: 4px 32px;
    color: #787878;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    box-shadow: none;
    &.active {
      color: white;
      border-bottom: 2px solid #fb263e;
      border-radius: 0;
      background-color: #fb263e;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
  }
}
</style>
